import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'

import { EnumMultipleSingleMode, EnumButtonSizes } from '@/enums/enums'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnDeleteSelectedInstitutional',
  setup(__props) {

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()

/**
 * ✅ MOSTRAR BOTÃO
 */
const showDeleteButton = computed(() => {
  return authStore.currentUserCanDeleteInstitutional
})

/**
 * ✅ CLICK EXCLUIR
 */
const onDeleteSelectedInstitutionalsBtnClick = () => {
  pagesUtilStore.modalDeleteInstitutionalConfirmationMode =
    EnumMultipleSingleMode.MULTIPLE

  pagesUtilStore.showModalDeleteInstitutionalConfirmation = true
}

/**
 * ✅ DESABILITAR BOTÃO
 */
const disableDeleteSelectedInstitutionalsBtn = computed(() => {
  try {
    return (
      institutionalStore.selectedInstitutionals.length === 0 ||
      !institutionalStore.canDeleteSelectedInstitutionals
    )
  } catch (error) {
    return true
  }
})


return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (showDeleteButton.value)
    ? (_openBlock(), _createBlock(_component_c_q_btn, {
        key: 0,
        id: "btn-delete-selected-institutionals",
        propBtnLabel: "Excluir",
        propBtnFunction: onDeleteSelectedInstitutionalsBtnClick,
        propBtnTransparent: true,
        propBtnSize: _unref(EnumButtonSizes).LARGE_1,
        disable: disableDeleteSelectedInstitutionalsBtn.value
      }, null, 8, ["propBtnSize", "disable"]))
    : _createCommentVNode("", true)
}
}

})